import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import ActionAdd from '../../store/action/Holiday/Add'
import ActionEdit from '../../store/action/Holiday/Edit'
import ActionGetClientAll from '../../store/action/Client/FetchAll'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import { ClientId } from '../../helper/HelperAuth'

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'holiday-id':'',
        'date' : '',
        'auto-reply' : '',
        'status' : '',
        'client-id':'',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    this.setState({ form:formVal })
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;
    if(form.get('auto-reply') === '' || form.get('date') === ''){
        this.setState({error : "Mandatory field cannot be empty!"});
        toast.error('All field cannot be empty!', toast.POSITION.TOP_RIGHT);
    }else{

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code block
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {
            'data' : 
            {
                'client-id': form.get('client-id'),
                'date': form.get('date'),
                'auto-reply': form.get('auto-reply'),
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
                'holidays-id': form.get('holiday-id'),
                'client-id': form.get('client-id'),
                'date': form.get('date'),
                'auto-reply': form.get('auto-reply'),
            }
        };

        var response = await this.props.actionEdit(data);
        if(response.ok){  
          toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentDidMount(){
    this.props.actionGetClientAll()
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS({
            'holiday-id' : this.props.item.get('holiday-id'),
            'date' : this.props.item.get('date'),
            'auto-reply' : this.props.item.get('auto-reply'),
            'client-id' : this.props.item.get('client-id'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
              <span className="col-sm-2">Client</span>
              <div className="col-sm-10">
              <ComboboxInput
                    field='client-id'
                    value={form.get('client-id')}
                    options={fromJS({
                        'source': this.props.clientall,
                        'value': 'client-id',
                        'label': 'client-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Client"
                    disabled={disabled}
                    hasError={errors.has('client-id')}
                />  
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Auto Reply</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'auto-reply'}
                      value={ form.get('auto-reply')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="auto-reply"
                      disabled={ disabled }
                      hasError={errors.has('auto-reply')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Date</span>
              <div className="col-sm-10">
                    <DatePickerInput
                        convertvalue
                        field="date"
                        value={ form.get('date') }
                        onChange={(field, date) => this.handleChange(field, date)}
                    />
              </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
              <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button"
                  className="btn btn-wide btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
        </div>
    );
  }
}


export default connect(
  (state) => {
      return {
          clientall: state.user.clientall
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
      actionGetClientAll: ActionGetClientAll,
  }, dispatch),
)(Form);